var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "calc(100vh - 228px)", "overflow-y": "auto" } },
    [
      _vm.trackData.length > 0
        ? _c(
            "el-collapse",
            {
              attrs: { accordion: "" },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            _vm._l(_vm.trackData, function (orderItem, orderIndex) {
              return _c(
                "el-collapse-item",
                {
                  key: orderIndex,
                  attrs: { title: orderItem.number, name: orderIndex },
                },
                [
                  _c("template", { slot: "title" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "font-size": "16px",
                          "font-weight": "bold",
                          "line-height": "18px",
                        },
                      },
                      [
                        _c("span", { class: orderItem.trackIcon }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              float: "left",
                            },
                          },
                          [_vm._v(" " + _vm._s(orderItem.number) + " ")]
                        ),
                        orderItem.nowTrack && orderItem.nowTrack.length > 0
                          ? _c("span", [
                              orderItem.nowTrack[0].scanTime
                                ? _c(
                                    "span",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [
                                      _vm._v(
                                        _vm._s(orderItem.nowTrack[0].scanTime)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "10px" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(orderItem.nowTrack[0].status) +
                                      " "
                                  ),
                                ]
                              ),
                              orderItem.nowTrack[0].siteName
                                ? _c(
                                    "span",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("collectionCenter.site")
                                        ) +
                                          ":【" +
                                          _vm._s(
                                            orderItem.nowTrack[0].siteName
                                          ) +
                                          "】"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              orderItem.nowTrack[0].signName
                                ? _c(
                                    "span",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("collectionCenter.operator")
                                        ) +
                                          ":【" +
                                          _vm._s(
                                            orderItem.nowTrack[0].signName
                                          ) +
                                          "】"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : orderItem.vehicleNowTrack &&
                            orderItem.vehicleNowTrack.length > 0
                          ? _c("span", [
                              orderItem.vehicleNowTrack[0].scanTime
                                ? _c(
                                    "span",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          orderItem.vehicleNowTrack[0].scanTime
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "10px" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        orderItem.vehicleNowTrack[0].status
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              orderItem.vehicleNowTrack[0].siteName
                                ? _c(
                                    "span",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("collectionCenter.site")
                                        ) +
                                          ":【" +
                                          _vm._s(
                                            orderItem.vehicleNowTrack[0]
                                              .siteName
                                          ) +
                                          "】"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              orderItem.vehicleNowTrack[0].driverName
                                ? _c(
                                    "span",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("order.driver")) +
                                          ":【" +
                                          _vm._s(
                                            orderItem.vehicleNowTrack[0]
                                              .driverName
                                          ) +
                                          "】"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "timelineItem",
                      staticStyle: {
                        "padding-left": "20px",
                        "border-top": "1px solid #eee",
                        "padding-top": "15px",
                      },
                    },
                    [
                      orderItem.trackStatuses &&
                      orderItem.trackStatuses.length > 0
                        ? _c(
                            "el-timeline",
                            _vm._l(
                              orderItem.trackStatuses,
                              function (item, index) {
                                return _c("el-timeline-item", {
                                  key: index,
                                  attrs: {
                                    color: index === 0 ? "#00A551" : "",
                                    timestamp:
                                      (item.scanTime ? item.scanTime : "") +
                                      (item.status ? "；" + item.status : "") +
                                      (item.siteName
                                        ? "；" +
                                          _vm.$t("collectionCenter.site") +
                                          "：【" +
                                          item.siteName +
                                          "】"
                                        : "") +
                                      (item.signName
                                        ? "；" +
                                          _vm.$t("collectionCenter.operator") +
                                          "：【" +
                                          item.signName +
                                          "】"
                                        : "") +
                                      (item.nextSiteName
                                        ? "；" +
                                          _vm.$t("GlobalSetObj.nextStation") +
                                          "：" +
                                          item.nextSiteName
                                        : "") +
                                      (item.tagNum
                                        ? "；" +
                                          _vm.$t("collectionCenter.carNumber") +
                                          "：" +
                                          item.tagNum
                                        : ""),
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                      orderItem.vehicleTrack &&
                      orderItem.vehicleTrack.length > 0
                        ? _c(
                            "el-timeline",
                            _vm._l(
                              orderItem.vehicleTrack,
                              function (item, index) {
                                return _c("el-timeline-item", {
                                  key: index,
                                  attrs: {
                                    color: index === 0 ? "#00A551" : "",
                                    timestamp:
                                      (item.scanTime ? item.scanTime : "") +
                                      (item.status ? "；" + item.status : "") +
                                      (item.siteName
                                        ? "；" +
                                          _vm.$t("collectionCenter.site") +
                                          "：【" +
                                          item.siteName +
                                          "】"
                                        : "") +
                                      (item.driverName
                                        ? "；" +
                                          _vm.$t("order.driver") +
                                          "：【" +
                                          item.driverName +
                                          "】"
                                        : ""),
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                      (!orderItem.vehicleTrack ||
                        orderItem.vehicleTrack.length === 0) &&
                      (!orderItem.trackStatuses ||
                        orderItem.trackStatuses.length === 0)
                        ? _c(
                            "div",
                            { staticStyle: { "text-align": "center" } },
                            [_vm._v(_vm._s(_vm.$t("orderCenterCont.NotFound")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }